import { HostComponent } from './../../layout/host/host.component';
import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { StorageConstants } from '@picard/shared-lib';
import { PreAuthenticationResponse, LogonResponse, LoyaltyTransactionLogModel } from '@picard/models-lib';
import { BreadcrumbService, LoyaltyService, ApplicationService } from '@picard/services-lib';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Title } from '@angular/platform-browser';

import moment from 'moment';

export const dateFormats = {
  customDateTimeFormat: 'YYYY/MM/DD HH:mm:SS:SSS',
  customDateTimeFormat1: 'YYYY/MM/DD HH:mm:SS',
  seattleDateTimeFormat: 'ddd, DD MMM YYYY HH:mm',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
  dateOnlyFormat: 'DD/MM/YYYY',
  monthYearFormat: 'MM/YYYY',
  isoFormat: 'YYYY-MM-DD HH:mm:SS ' // Corresponds to '2016-01-04T13:00:00Z'
};

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  logonResponse: LogonResponse;
  loyaltyTransactionLogModelCollection: LoyaltyTransactionLogModel[];
  cols: any[];
  colsPauls: any[];
  datasource: any[] = Array<any>();
  isMobile = false;
  @BlockUI() blockUI: NgBlockUI;
  docTheme = document.getElementById('theme-css');
  docLayout = document.getElementById('layout-css');
  programId: number;
  //#endregion Properties

  //#region Constructor
  constructor(private _breadcrumbService: BreadcrumbService, public hostComponent: HostComponent, private _loyaltyService: LoyaltyService, private _title: Title, private _applicationService: ApplicationService) {
    this.programId = parseInt(sessionStorage.getItem('programID'));//this._applicationService.preAuthenticationResponse.programId;
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));
    this._breadcrumbService.setItems([{ label: `${this.preAuthenticationResponse.description} - History`, routerLink: '/history' }]);
    setInterval(() => {
      this.isMobile = hostComponent.isMobile();
    }, 2000);
    if (this.docTheme) {
      this.docTheme.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.layout);
    }
  }
  //#endregion Constructor

  //#region Functions
  async ngOnInit() {
    this._title.setTitle(`${this.preAuthenticationResponse.description} - Transaction History`);
    this.logonResponse = JSON.parse(sessionStorage.getItem(StorageConstants.loginDetails));
    this.blockUI.start('Loading history.');
    this.loyaltyTransactionLogModelCollection = await this._loyaltyService.GetLoyaltyTransactionLogModelsAsync();
    this.blockUI.stop();
    this.loyaltyTransactionLogModelCollection.forEach(x => {
      var transactionType = "transaction";
      switch(x.transactionTypeId) {
        case 0:
          transactionType = "Accrue";
          //if (this.programId === 2555) transactionType = "Points Earned";
          break;
        case 1:
          transactionType = "Spend";
          break;
        case 2:
          transactionType = "Points Convert";
          //if (this.programId === 2555) transactionType = "Points Redeemed";
          break;
        case 3:
          transactionType = "Admin Modification";
          break;
        case 4:
          transactionType = "Sync";
          break;
        case 5:
          transactionType = "Void Transaction";
          break;
        case 6:
          transactionType = "Created";
          break;
        case 7:
          transactionType = "Migration";
          break;
        default:
          transactionType = "transaction";
      }
      this.datasource.push({ transactionType: transactionType, createDateUTC: moment.utc(x.createDateUTC).local().format(dateFormats.seattleDateTimeFormat), pointsCount: x.pointsCount, rewardsCount: x.rewardsCount, siteName: x.sitesModel.siteName });
    });
    this.datasource.sort().reverse();
    // this.cols = [{ field: 'createDateUTC', header: 'Purchase Date' }, { field: 'pointsCount', header: 'Points Count' }, { field: 'rewardsCount', header: 'Rewards Count' }, { field: 'siteName', header: 'Location Name' }];
    this.cols = [{ field: 'createDateUTC', header: 'Purchase Date' }, { field: 'transactionType', header: 'Transaction' }, { field: 'pointsCount', header: 'Points Accrued' }, { field: 'rewardsCount', header: 'Rewards Accrued' }, { field: 'siteName', header: 'Location Name' }];
    this.colsPauls = [{ field: 'createDateUTC', header: 'Purchase Date' }, { field: 'pointsCount', header: 'Points Accrued' }, { field: 'rewardsCount', header: 'Rewards Accrued' }, { field: 'siteName', header: 'Locations' }];
  }
  isDate(field: string): { valid: boolean; val: Date | null | moment.Moment | string } {
    const parameters = Array<string>();
    parameters.push(dateFormats.customDateTimeFormat);
    parameters.push(dateFormats.customDateTimeFormat1);
    const parse = toDate(field, parameters);
    return parse;
  }
  //#endregion Functions
}

export function toDate(value: string, formats = [dateFormats.customDateTimeFormat, dateFormats.dateTimeFormat, dateFormats.dateOnlyFormat, dateFormats.isoFormat, dateFormats.monthYearFormat, dateFormats.customDateTimeFormat1]): { valid: boolean; val: Date | null | moment.Moment | string } {

  const trimmed = String(value).trim();
  if (!formats.some(format => format.length === trimmed.length)) {
    return { valid: false, val: value };
  }
  const date = moment(value);
  if (!date.isValid()) {
    return { valid: false, val: value };
  }
  return { valid: true, val: date.format('YYYY-MM-DD HH:mm:ss') };
}
